import React from 'react'
import classNames from 'classnames'
import { WemoloTypography } from '../../../components/Wemolo'
import { DETECTION_EXPLORER_TEXT } from '../config'
import { ALL_IMAGE_TYPES, ImageType } from '../request_images'
import styles from './AssetTypePicker.module.css'

const { imageTypes } = DETECTION_EXPLORER_TEXT

// Rendered in ALL_IMAGE_TYPES order (render, roi, lp).
const OPTIONS: ReadonlyArray<{ type: ImageType; label: string; description: string }> = ALL_IMAGE_TYPES.map((type) => ({
    type,
    label: imageTypes[type].label,
    description: imageTypes[type].description
}))

type Props = {
    value: ImageType[]
    onChange: (next: ImageType[]) => void
    disabled?: boolean
    className?: string
}

// Multi-select of detection image artifacts, shared by the export and retrieve flows. A compact
// row of toggle buttons; nothing is selected initially so the caller's action stays disabled
// until the user picks at least one type.
export const AssetTypePicker: React.FC<Props> = ({ value, onChange, disabled, className }) => {
    const toggle = (type: ImageType) =>
        onChange(value.includes(type) ? value.filter((t) => t !== type) : [...value, type])

    return (
        <div className={classNames(styles.picker, className)}>
            <WemoloTypography variant="label-xsmall" tag="span" className={styles.heading}>
                {imageTypes.title}
            </WemoloTypography>
            <div className={styles.row}>
                {OPTIONS.map(({ type, label, description }) => {
                    const checked = value.includes(type)
                    return (
                        <button
                            key={type}
                            type="button"
                            title={description}
                            className={classNames(styles.option, checked && styles.optionSelected)}
                            onClick={() => toggle(type)}
                            disabled={disabled}
                            aria-pressed={checked}
                        >
                            <WemoloTypography variant="label-small" tag="span">
                                {label}
                            </WemoloTypography>
                        </button>
                    )
                })}
            </div>
        </div>
    )
}
